import { routerReducer } from 'react-router-redux'
import { route } from '../selectors/common'

let typeToRoute = {
    'transaction/bill': 'transaction',
    'transaction/invoice': 'transaction',
    'transaction/invoice-payment': 'transaction',
    'transaction/invoice-deposit': 'transaction',
    'merchant': 'vendor',
    'term': 'term',
    'listing': 'listing',
    'project': 'project',
    'property': 'property',
    'lease': 'lease',
    'tenant': 'tenant',
	  'task': 'task',
    'owner': 'owner',
}

let plurals = {
    'merchant': 'merchants',
    'transaction': 'transactions',
    'vendor': 'vendors',
    'term': 'terms',
    'listing': 'listings',
    'tenant': 'tenants',
    'property': 'properties',
    'lease': 'leases',
  	'project': 'projects',
  	'task': 'tasks',
  	'repairman': 'repairmen',
  	'agent': 'agents',
  	'owner': 'owners',
  	'template': 'templates',
  	'tenant': 'tenants',
    '': ''
}

let unPlurals = {
    'merchants': 'merchant',
    'transactions': 'transactions',
    'vendors': 'vendor',
    'terms': 'term',
    'listings': 'listing',
    'leases': 'leases'
}

export default (state, action, megastate) => {
    let current = route(megastate)
    // if (action.type == '@@router/LOCATION_CHANGE' || action.type == 'ADD' || action.type == 'CLOSE') {
    //     if (megastate.mode == 'edit' || megastate.mode == 'creating'){
    //       return state
    //     }
    // }
    if (action.type == 'ADD') {
        let single = typeToRoute[action.data.type]
        let plural = plurals[single]
        let pathname = '/manager/' + (current[0] == plural ? plural : single) + '/' + action._id
        if (action.data.type === 'lease' && action.data.parentID){
            pathname = '/manager/term/' + action._id
        }
        return {...state, locationBeforeTransitions: {...state.locationBeforeTransitions, pathname}}
    }
    if (action.type == 'CHOOSE_ITEM') {
        let pathname = '/manager/' + (unPlurals[current[0]] || current[0]) + '/' + action.data.id
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
	if (action.type == 'NAVIGATE') {
        let pathname = '/manager/' + action.data
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
    if (action.type == 'NEW_PROJECT') {
        let pathname = '/manager/projects/NewProject'
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
    if (action.type == 'NEW_PAYMENT') {
        let pathname = '/manager/transaction/' + action._id
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
    if (action.type == 'NEW_APPLICATION') {
        let pathname = ('/rent/' + action.data.alias).replace(/ /g,"_").toLowerCase()
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
    if (action.type == 'CLOSE' || action.type == 'CLOSE_YES' || action.type == 'OK') {
        let pathname = '/manager/' + (plurals[current[0]] || current[0])
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
	if (action.type == 'OPEN_PREFILTERED' || action.type == 'NAVIGATION') {
		let pathname = '/manager/' + (plurals[action.data.entity] || action.data.entity)
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname, key: null } }
	}
	if (action.type == 'ACCEPT_APPLICATION') {
		let pathname = '/manager/lease/' + action.data._id + "0"
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
	}
	if (action.type == 'NAVIGATE') {
        let pathname = '/manager/' + action.data
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
    }
    return routerReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/reducers/routing.manager.js